import React, { FC } from "react";

import { HomeWorksPage } from "./HomeWorksPage";

export const HomeFirmWorks: FC = () => {
  return <HomeWorksPage title={"Firm's work"} isMyWork={false} />;
};
